/**
 * Created by maximus on 08.11.16.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _class, _class2, _temp;

var _reactRedux = require('react-redux');

var _helpers = require('helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    Paginator: {
        displayName: 'Paginator'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/Paginator/Paginator.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var limit = 9;
var limitsArray = ['12', '24', '48', '96', 'Все'];

var Paginator = _wrapComponent('Paginator')((_dec = (0, _reactRedux.connect)(function (state) {
    return {
        lang: state.lang
    };
}), _dec(_class = (_temp = _class2 = function (_Component) {
    (0, _inherits3.default)(Paginator, _Component);

    function Paginator(props) {
        (0, _classCallCheck3.default)(this, Paginator);

        var _this = (0, _possibleConstructorReturn3.default)(this, (Paginator.__proto__ || (0, _getPrototypeOf2.default)(Paginator)).call(this, props));

        _this.getPaginatorSize = function (size, limit) {
            if (limit === 0 || size < limit) {
                return 0;
            } else if (size % limit === 0) {
                return size / limit;
            }
            return Math.floor(size / limit) + 1;
        };

        _this.handleChangeActivePage = function (page) {
            _this.props.handleChangePage(page, _this.props.limit);
        };

        _this.handleChangeSelect = function (value) {
            var limit = limitsArray[value] === 'Все' ? _this.props.count : parseInt(limitsArray[value]);
            _this.props.handleChangePage(1, limit);
        };

        return _this;
    }

    (0, _createClass3.default)(Paginator, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                activePage = _props.activePage,
                count = _props.count,
                limit = _props.limit,
                lang = _props.lang;

            var arrayOfLimits = this.props.limitsArray || limitsArray;
            var pages = this.getPaginatorSize(count, limit);
            var pageLimit = limit === count ? 'Все' : limit;
            //limit === count && ( limit = 'Все');

            var View = _helpers.ThemeHelper.getViewForComponent('Paginator');

            return _react3.default.createElement(View, {
                activePage: activePage,
                pages: pages,
                limitsArray: arrayOfLimits,
                limit: pageLimit,
                count: count,
                handleChangeActivePage: this.handleChangeActivePage,
                handleChangeSelect: this.handleChangeSelect,
                lang: lang
            });
        }
    }]);
    return Paginator;
}(_react2.Component), _class2.propTypes = {
    activePage: _react2.PropTypes.any,
    count: _react2.PropTypes.any,
    limit: _react2.PropTypes.any,
    lang: _react2.PropTypes.object
}, _temp)) || _class));

exports.default = Paginator;
;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Paginator/Paginator.jsx
// module id = 1716
// module chunks = 0